// File generated from our OpenAPI spec
export const ApiVersion = '2026-02-25.clover';
export const ApiMajorVersion = 'clover';
